import { useQuery } from '@tanstack/react-query';
import { isAxiosError } from 'axios';

import axiosClient from '../lib/api';

const useCurrentUser = () => {
  const getCurrentUser = async () => {
    try {
      const response = await axiosClient.get('/users/me');
      return response.data;
    } catch (error) {
      // 비로그인(401/403)은 게스트로 취급해 페이지 진입을 막지 않는다.
      // (전역 suspense/useErrorBoundary 설정으로 throw 시 ErrorBoundary로 튕기는 것 방지)
      // 그 외 에러(5xx, 네트워크 등)는 그대로 전파하여 ErrorBoundary가 처리하게 한다.
      if (isAxiosError(error) && (error.response?.status === 401 || error.response?.status === 403)) {
        return null;
      }
      throw error;
    }
  };

  const { data, isLoading, isError } = useQuery({
    queryKey: ['/users/me'],
    queryFn: getCurrentUser,
    refetchOnMount: true,
  });

  return { user: data, isLoading, isError, isLogin: !!data };
};

export default useCurrentUser;
